// extracted by mini-css-extract-plugin
export default {"root":"styles_root__OIMHo","disabled":"styles_disabled__2g+pD","btnWrap":"styles_btnWrap__zxlkc","actionBtn":"styles_actionBtn__imaEg","up":"styles_up__kMxH+"};